// extracted by mini-css-extract-plugin
export default {"login":"styles_login__2hrYC","login__logo":"styles_login__logo__0XQ2m","login__button":"styles_login__button__z6PZj"};